"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2044],{

/***/ 42044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var MobileRequestEstimate = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "h-[70px] relative",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: "/contact-us",
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "#",
                "aria-label": "contact page",
                className: "text-white hover:text-redblack absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2\n                    text-[.85714rem] font-bold uppercase z-[9997]  cursor-pointer transition ease-in-out duration-300 z-1 lg:hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "-translate-y-6",
                    children: "WORK WITH US"
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MobileRequestEstimate);


/***/ })

}]);